import ParseHelper from './ParseHelper';

const auth = {
  signInWithEmailAndPassword: async (email, password) => {
    const res = await ParseHelper.Login(email, password);
    return res.result ? { user: res.user } : { message: res.message };
  },
  createUserWithEmailAndPassword: async (email, password, name) => {
    const res = await ParseHelper.SignUp(email, password, { email, name });
    const result = res.result ? { user: res.user } : { message: res.message };
    return result;
  },
  signOut: async () => {
    await ParseHelper.Logout();
  },
  sendPasswordResetEmail: async (email) => {
    return { result: true, email };
  },
  confirmPasswordReset: async (resetPasswordCode, newPassword) => {
    return { result: true, resetPasswordCode, newPassword };
  },
};
export default auth;
